module.exports = __webpack_public_path__ + "static/img/item-two-guide.3a52d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/library/item-two-guide.png
// module id = Fcl1
// module chunks = 2